import React, { useState } from "react";
import { Modal, Button, Tabs, Tab, CloseButton } from "react-bootstrap";
import {
  WONT_SEE_FIELD_AFTER_REJECTING_REQUEST,
  DELETE_SHARED_FIELD,
  REJECT_SHARED_FIELD,
} from "../../configurations/MessageConstants";
import { DELETE_SHARE, REJECT_SHARE } from "../../configurations/Constants";

function DeleteShareFieldPopUp(props) {
  const [buttonClicked, setButtonClicked] = useState(false);

  const handleRequest = (event, index) => {
    setButtonClicked(true);
    props.performWarningAction(event, index);
  };
  const closeModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.closeWarningPopup();
  };

  const close = () => {};
  return (
    <Modal show={props.showConfirmPopup} onHide={close} className="remove-crop">
      <Modal.Header>
        <h3>{props.header}</h3>
        <CloseButton
          className="close"
          variant="white"
          onClick={(event) => closeModal(event)}
        />
      </Modal.Header>
      <Modal.Body>
        <Tabs defaultActiveKey={DELETE_SHARE}>
          <Tab eventKey={DELETE_SHARE} title="Delete Field">
            <p color="muted">
              {DELETE_SHARED_FIELD} "{props.selectedField}" ?
              <br />
            </p>
            <Button
              type="button"
              onClick={(e) => handleRequest(e, 0)}
              disabled={buttonClicked ? true : false}
            >
              Yes
            </Button>{" "}
            <Button
              type="button"
              onClick={(e) => props.closeWarningPopup(e)}
              disabled={buttonClicked ? true : false}
            >
              No
            </Button>
          </Tab>
          <Tab eventKey={REJECT_SHARE} title="Reject Field">
            <p color="muted">
              {WONT_SEE_FIELD_AFTER_REJECTING_REQUEST}. {REJECT_SHARED_FIELD} "
              {props.selectedField}" ?
            </p>
            <Button
              type="button"
              onClick={(e) => handleRequest(e, 1)}
              disabled={buttonClicked ? true : false}
            >
              Yes
            </Button>{" "}
            <Button
              type="button"
              onClick={(e) => props.closeWarningPopup(e)}
              disabled={buttonClicked ? true : false}
            >
              No
            </Button>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteShareFieldPopUp;
